





























































import { Vue, Component, Prop } from 'vue-property-decorator'
import TeamAvatar from '@/modules/shared/components/TeamAvatar'
import { dateTime } from '@/utils'

@Component({
  components: {
    TeamAvatar
  },
  filters: {
    dateTime
  }
})
export default class TournamentHistoryItem extends Vue {
  @Prop({ required: true }) readonly tournamentId!: string
  @Prop({ required: true }) readonly tournamentBanner!: string
  @Prop({ required: true }) readonly tournamentLogo!: string
  @Prop({ required: true }) readonly tournamentName!: string
  @Prop({ required: true }) readonly teamName!: string
  @Prop({ required: true }) readonly teamLogo!: string
  @Prop({ required: true }) readonly tournamentTime!: number
  @Prop({ required: true }) readonly stageName!: string
  @Prop({ required: true }) readonly groupNumber!: number
  @Prop({ required: true }) readonly standing!: string

  /* Getters */
  get standingStr() {
    if (this.standing === 'TBC') {
      // To be confirmed
      return this.$t('TournamentHistoryItem.PendingForApproval')
    } else if (this.standing.match(/^[A-Za-z]+$/)) {
      switch (this.standing) {
        case 'Champion':
          return this.$t('TournamentHistoryItem.Champion')
        case 'FirstRunnerUp':
          return this.$t('TournamentHistoryItem.FirstRunnerUp')
        case 'SecondRunnerUp':
          return this.$t('TournamentHistoryItem.SecondRunnerUp')
        case 'ThirdRunnerUp':
          return this.$t('TournamentHistoryItem.ThirdRunnerUp')
      }
    } else if (this.standing.match(/^[A-Za-z]+/)) {
      return (
        this.standing.substring(0, this.standing.search(/\d/)) +
        ' ' +
        this.standing.substring(this.standing.search(/\d/))
      )
    } else {
      var i = parseInt(this.standing)
      var j = i % 10
      var k = i % 100
      if (j === 1 && k !== 11) {
        return i + 'st'
      }
      if (j === 2 && k !== 12) {
        return i + 'nd'
      }
      if (j === 3 && k !== 13) {
        return i + 'rd'
      }
      return i + 'th'
    }
  }

  /* Methods */
  isValidImage(image: string) {
    return image !== ''
  }

  async onTournamentHistoryItemClicked() {
    await this.$router.push({
      name: 'TournamentDetailsOverview',
      params: {
        tournamentId: this.tournamentId
      }
    })
  }
}
